import { render, staticRenderFns } from "./Registry.vue?vue&type=template&id=048456a2&scoped=true&"
import script from "./Registry.vue?vue&type=script&lang=js&"
export * from "./Registry.vue?vue&type=script&lang=js&"
import style0 from "./Registry.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Registry.vue?vue&type=style&index=1&id=048456a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048456a2",
  null
  
)

export default component.exports